// Initial settings used with first install
const initialSettingsData = {
  createdAt: Date.now(),
  vueAppVersion: '0.0.0',
  //
  // Global permissions
  //
  trackingAllowed: false,
  sensorsAllowed: false,
  //
  // Permission Status
  //
  geolocationPermissionStatus: 'prompt',
  gyroscopePermissionStatus: 'prompt',
  //
  // Geolocation specifics
  //
  enableHighAccuracy: false,
  maximumAge: 0,
  timeout: 5000,
  //
  // Reverse Geolocation
  //
  addressService: 'none',
  reverseGeoLocServices: ['none', 'nomatim', 'HERE', 'Google'],
  //
  // Geolocation Recording constrains
  //
  useMinSpeedThreshold: false,
  minSpeedThreshold: 0.9,
  useRecordingTimeInterval: false,
  recordingTimeInterval: 1500,
  //
  // Screen Wake-Lock Web API
  //
  screenWakeLock: false,
  //
  // Sensors: Gyroscope Web API
  //
  useSteps: false,
  //
  // Zoom (OpenLAyers)
  //
  zoomLevelFar: 0,
  zoomLevelNear: 14,
  //
  // Notifications
  //
  showNotificationWhenNotMoving: false,
  //
  // Pagination (Sidebar Sections)
  //
  maxMapHostsPerPage: 7,
  maxNotesPerPage: 7,
  maxTrackedRoutesPerPage: 12,
  //
  // Debugging
  //
  console: false,
  debugging: false,
  log: ''
}

export default initialSettingsData
